import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rruleParser',
  standalone: true
})
export class RruleParserPipe implements PipeTransform {

  transform(rrule: string): string {
    if (!rrule) {
      return 'Invalid RRULE';
    }
    const splitRule = rrule.split(':')[1];
    const parts = splitRule.split(';');
    const frequency = parts.find(part => part.startsWith('FREQ'));
    const interval = parts.find(part => part.startsWith('INTERVAL'));
    const until = parts.find(part => part.startsWith('UNTIL'));

    if (!frequency || !interval) {
      return 'Invalid RRULE';
    }

    const frequencyValue = frequency.split('=')[1];
    const intervalValue = interval.split('=')[1];

    let recurringPattern = `Repeats ${frequencyValue} every ${intervalValue} days`;

    const bydayPart = parts.find(part => part.startsWith('BYDAY'));
    if (bydayPart) {
      const bydayValues = bydayPart.split('=')[1].split(',');
      recurringPattern += ` on ${bydayValues.join(', ')}`;
    }

    if (until) {
      const untilValue = until.split('=')[1];
      const untilDate = new Date(Number(untilValue.slice(0, 4)), Number(untilValue.slice(4, 6)) - 1, Number(untilValue.slice(6, 8)));
      recurringPattern += ` until ${untilDate.toDateString()}`;
    }

    return recurringPattern + '.';
  }

}

